<!-- Feedback -->
<div class="ml-feedback-area ptb-80">
  <div class="container">
    <div class="section-title">
      <span class="sub-title" i18n="@@testimonialsSubtitle">Testimonials</span>
      <h3 i18n="@@whatUsersSayTitle">What Users Say</h3>
      <div class="bar"></div>
      <p i18n="@@whatUsersSayDescription">These are some opinions of those who join our community</p>
    </div>
    <div class="ml-feedback-slides">
      <owl-carousel-o [options]="feedbackSlides">
        <ng-template carouselSlide *ngFor="let item of feedback">
          <div class="single-testimonials-item">
            <p>
              {{ item.comment }}
            </p>
            <div class="client-info">
              <img *ngIf="item.userImage !== ''" [src]="item.userImage" alt="image" />

              <div class="rating">
                <i data-feather="star"></i>
                <i data-feather="star"></i>
                <i data-feather="star"></i>
                <i data-feather="star"></i>
                <i data-feather="star"></i>
              </div>
              <h3>{{ item.name }}</h3>
              <span>{{ item.position }}</span>
            </div>
          </div>
        </ng-template>
      </owl-carousel-o>
    </div>
  </div>
  <ng-template *ngIf="showAnimation">
    <div class="user-shape1"><img src="assets/img/agency-image/user1.png" alt="image" /></div>
    <div class="user-shape2"><img src="assets/img/agency-image/user2.png" alt="image" /></div>
    <div class="user-shape3"><img src="assets/img/agency-image/user3.png" alt="image" /></div>
    <div class="user-shape4"><img src="assets/img/agency-image/user4.png" alt="image" /></div>
    <div class="user-shape5"><img src="assets/img/agency-image/user5.png" alt="image" /></div>
    <div class="user-shape6"><img src="assets/img/agency-image/user6.png" alt="image" /></div>
  </ng-template>
</div>
